import { useEffect, useMemo } from 'react';
import {
  useVacancyControllerSearchVacancyResponsesByNamesMutation,
  VacancyResponseSearchByNamesRequest,
} from '@api/admin/adminGeneratedApi';

export interface ResponseItem {
  vacancyId: string;
  name: string;
  userName: string;
  stage: string;
  refused: boolean;
  refuseReason?: string | null;
  history?: { date: string; stage: string }[];
}

export interface UseGetResponsesProps {
  name?: string;
  userName?: string;
}

const MIN_FILTER_LENGTH = 2;

export const useGetResponses = ({ name, userName }: UseGetResponsesProps) => {
  const [searchResponses, searchResult] = useVacancyControllerSearchVacancyResponsesByNamesMutation();

  const trimmedName = name?.trim() || '';
  const trimmedUserName = userName?.trim() || '';

  const shouldSearch =
    (trimmedName.length === 0 && trimmedUserName.length === 0) ||
    trimmedName.length >= MIN_FILTER_LENGTH ||
    trimmedUserName.length >= MIN_FILTER_LENGTH;

  useEffect(() => {
    if (!shouldSearch) {
      return;
    }

    const request: VacancyResponseSearchByNamesRequest = {
      vacancyName: trimmedName || undefined,
      studentName: trimmedUserName || undefined,
    };

    searchResponses({ vacancyResponseSearchByNamesRequest: request });
  }, [trimmedName, trimmedUserName, searchResponses, shouldSearch]);

  const data = useMemo(
    () =>
      searchResult.data?.data?.map((item) => ({
        vacancyId: item.vacancyId,
        name: item.vacancyName,
        userName: item.studentName,
        stage: item.stage,
        refused: item.refused,
        refuseReason: item.refuseReason,
        history: item.history as unknown as { date: string; stage: string }[] | undefined,
      })) ?? [],
    [searchResult.data],
  );

  return {
    data,
    isLoading: searchResult.isLoading,
  };
};
